module.exports = __webpack_public_path__ + "static/media/blog4_3.fb50fcbd.webp";